import React from "react";
import { Helmet } from "react-helmet";
import { useData } from "../../context/DataContext";

const Head = ({title}) => {
  const { website_details } = useData()
  return (
    <Helmet>
      <link
        href={website_details?.favicon[0]?.src || ""}
        rel="icon"
      />
      <title>{website_details?.website_name || ""} || {title}  </title>
    </Helmet>
  );
};

export default Head;
